Monet = Monet || {};
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.ToggleNumber = (function () {

    function ToggleNumber () {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.createBaseStructure();

        this.checkBox = null;
        this.number = null;
        this.label = null;
        this.complementLabel = null;
        this.value = {};

        var baseElement = null;

        const toggleValue = (function () {
            this.number.setMandatory(this.checkBox.getValue());
            this.checkBox.getValue() ? this.number.enable() : this.number.disable();
        }).bind(this);

        this.getValue = function () {
            return this.checkBox.getValue() ? this.number.getValue() : null;
        };

        this.setValue = function (number) {
            this.checkBox.setValue(!!number);
            this.number.setValue(number);
            toggleValue();
        };

        this.setTextLabel = function (label) {
            this.label = label;
        };

        this.setTextComplementLabel = function (complementLabel) {
            this.complementLabel = complementLabel
        };

        this.render = function () {
            if (!baseElement) {
                this.checkBox = new Monet.UI.Fields.Checkbox;
                this.number = new Monet.UI.Fields.Number;

                this.checkBox.setTextLabel(this.label);
                this.number.setTextLabel(this.complementLabel);

                const firstChild = this.rootEl.firstChild;
                firstChild.parentNode.removeChild(firstChild);
                this.rootEl.className += ' toggleNumber';

                baseElement = this.rootEl;

                const checkDOM = this.checkBox.render();
                const numberDOM = this.number.render();

                checkDOM.className = "checkBox";
                numberDOM.className = "numberValue";

                numberDOM.insertBefore(numberDOM.children[1], numberDOM.children[0]);

                toggleValue();
                checkDOM.onchange = toggleValue;
                
                this.rootEl.appendChild(checkDOM);
                this.rootEl.appendChild(numberDOM);
            }

            return this.rootEl;
        };

        this.validate = function () {
            return this.number.validate();
        };

        this.clear = function () {
            this.checkBox.clear();
            this.number.clear();
            toggleValue();
        };

    }

    return ToggleNumber;

}());